import { useEffect, useState } from "react";
import { useFlag, useFlagsStatus } from "@unleash/proxy-client-react";
import { FEATURE_FLAGS } from "../../constants/FeatureFlag";

export const FLAG_RESOLUTION_TIMEOUT_MS = 3000;

const useNewAuthServiceFlow = () => {
  const isEnabled = useFlag(FEATURE_FLAGS.RELEASE.ENABLE_NEW_AUTH_SERVICE);
  const { flagsReady, flagsError } = useFlagsStatus();
  const [resolvedFlow, setResolvedFlow] = useState(null);

  useEffect(() => {
    if (resolvedFlow !== null) {
      return undefined;
    }

    if (flagsError) {
      setResolvedFlow(false);
      return undefined;
    }

    if (flagsReady) {
      setResolvedFlow(isEnabled);
      return undefined;
    }

    const timeoutId = setTimeout(
      () => setResolvedFlow(false),
      FLAG_RESOLUTION_TIMEOUT_MS
    );

    return () => clearTimeout(timeoutId);
  }, [resolvedFlow, flagsReady, flagsError, isEnabled]);

  return {
    isEnabled: resolvedFlow === true,
    isReady: resolvedFlow !== null
  };
};

export default useNewAuthServiceFlow;
